<template>
  <div>
    <div class="main-content mt-2">
      <div class="row">
        <div class="container-fluid container-fluid-height my-0">
          <div class="dax-search-content">
            <div class="row" v-if="!$route.query.id">
              <div class="col-12">
                <div class="heading">
                  <h1>Paste, Save and Edit your own Code in any language.</h1>
                </div>
              </div>
            </div>
            <div class="updated-message-wrapper" v-if="successUpdateMessage">
              <div class="updated-message" style="display: block">
                <p>
                  <img src="/assets/img/checkbox-outline.svg" alt="" />{{
                    successUpdateMessage
                  }}
                </p>
              </div>
            </div>
            <div class="row">
              <div
                class="
                  col-12 col-sm-7 col-lg-9 col-xl-10
                  order-2 order-sm-1
                  mb-5
                "
              >
                <user-card
                  v-if="$parent.documentData.user"
                  class="ml-0 mt-2"
                ></user-card>
                <div class="dax-search-code editor-wrapper preview">
                  <div class="dax-search-code-form" v-if="!showResults">
                    <textarea-autosize
                      v-on:keydown.tab.prevent="tabber($event)"
                      class="form-control"
                      v-model="code"
                      :min-height="20"
                      :max-height="800"
                      placeholder="Paste your R Code HERE"
                    />
                  </div>
                  <div class="editor-preview-edit-mode rawcode-snippet">
                    <prism
                      class="line-numbers"
                      :plugins="['line-numbers']"
                      :code="code"
                      style="max-height: 545px"
                      v-if="showResults"
                    ></prism>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-edited-btn" v-if="code" v-cloak>
      <div class="btn-edit-left">
        <button
          @click="showResults = !showResults"
          v-if="showResults && !readOnly"
          class="btn btn-edit-rawcode"
        >
          EDIT
        </button>
        <a
          @click="newDoc()"
          v-if="code && onceFormatted && showResults"
          class="btn btn-primary"
          >NEW</a
        >
        <button
          @click="showResults = !showResults"
          v-if="!showResults && code"
          class="btn btn-outline-primary delete-document-popup"
        >
          COMMIT
        </button>
      </div>
      <div class="btn-copy-right">
        <button
          @click="copyToClipboard()"
          v-if="showResults"
          class="btn btn-outline-primary delete-document-popup"
        >
          {{ copyCodeBtnText }}
        </button>
        <button
          @click="saveDocument()"
          v-if="!edit && code && showResults"
          class="btn btn-outline-primary save-document-popup"
        >
          SAVE THIS FORMULA
        </button>
        <button
          @click="updateDocument()"
          v-if="edit && !readOnly"
          class="btn btn-outline-primary save-document-popup"
        >
          {{ updateBtnText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DaxHttpService from "../services/DaxHttpService";
import sqlFormatter from "sql-formatter";
import sqlFormatter2 from "../util/sql-formatter";
import DaxFormula from "./partials/DaxFormula";
import UserCard from "./partials/UserCard";
import Prism from "vue-prismjs";
import Avatar from "vue-avatar";

export default {
  name: "RCode",
  props: ["docData"],
  components: {
    DaxFormula,
    UserCard,
    Prism,
    Avatar,
  },
  data: function () {
    return {
      document: null,
      code: null,
      settings: {
        setting_title: {
          automatic: true,
          comma: false,
          semicolon: false,
        },
        spacing: {
          best_practice: true,
          space_after_function: false,
        },
        lines: {
          long_lines: false,
          short_lines: true,
        },
      },

      showResults: false,

      edit: false,
      readOnly: false,

      copyCodeBtnText: "COPY CODE",
      updateBtnText: "UPDATE",

      lookUpFormula: false,

      daxFunctions: [
        "ABS",
        "ACOS",
        "ACOSH",
        "ADDCOLUMNS",
        "ADDMISSINGITEMS",
        "ALL",
        "ALLCROSSFILTERED",
        "ALLEXCEPT",
        "ALLNOBLANKROW",
        "ALLSELECTED",
        "AND",
        "APPROXIMATEDISTINCTCOUNT",
        "ASIN",
        "ASINH",
        "ATAN",
        "ATANH",
        "AVERAGE",
        "AVERAGEA",
        "AVERAGEX",
        "BETA.DIST",
        "BETA.INV",
        "BLANK",
        "CALCULATE",
        "CALCULATETABLE",
        "CALENDAR",
        "CALENDARAUTO",
        "CEILING",
        "CHISQ.INV",
        "CHISQ.INV.RT",
        "CLOSINGBALANCEMONTH",
        "CLOSINGBALANCEQUARTER",
        "CLOSINGBALANCEYEAR",
        "CODE",
        "COMBIN",
        "COMBINA",
        "CONCATENATE",
        "CONCATENATEX",
        "CONFIDENCE.NORM",
        "CONFIDENCE.T",
        "CONTAINS",
        "CONTAINSSTRING",
        "CONTAINSSTRINGEXACT",
        "CONVERT",
        "COS",
        "COSH",
        "COUNT",
        "COUNTA",
        "COUNTAX",
        "COUNTBLANK",
        "COUNTROWS",
        "COUNTX",
        "CROSSFILTER",
        "CROSSJOIN",
        "CURRENCY",
        "CUSTOMDATA",
        "DATATABLE",
        "DATE",
        "DATEADD",
        "DATEDIFF",
        "DATESBETWEEN",
        "DATESINPERIOD",
        "DATESMTD",
        "DATESQTD",
        "DATESYTD",
        "DATEVALUE",
        "DAY",
        "DEGREES",
        "DISTINCT (column)",
        "DISTINCT (table)",
        "DISTINCTCOUNT",
        "DISTINCTCOUNTNOBLANK",
        "DIVIDE",
        "EARLIER",
        "EARLIEST",
        "EDATE",
        "ENDOFMONTH",
        "ENDOFQUARTER",
        "ENDOFYEAR",
        "EOMONTH",
        "ERROR",
        "EVEN",
        "EXACT",
        "EXCEPT",
        "EXP",
        "EXPON.DIST",
        "FACT",
        "FALSE",
        "FILTER",
        "FILTERS",
        "FIND",
        "FIRSTDATE",
        "FIRSTNONBLANK",
        "FIXED",
        "FLOOR",
        "FORMAT",
        "GCD",
        "GENERATE",
        "GENERATEALL",
        "GENERATESERIES",
        "GEOMEAN",
        "GEOMEANX",
        "GROUPBY",
        "HASONEFILTER",
        "HASONEVALUE",
        "HOUR",
        "IF",
        "IFERROR",
        "IN",
        "CONTAINSROW",
        "INT",
        "INTERSECT",
        "ISBLANK",
        "ISCROSSFILTERED",
        "ISEMPTY",
        "ISERROR",
        "ISEVEN",
        "ISFILTERED",
        "ISINSCOPE",
        "ISLOGICAL",
        "ISNONTEXT",
        "ISNUMBER",
        "ISO.CEILING",
        "ISONORAFTER",
        "ISSELECTEDMEASURE",
        "ISTEXT",
        "KEEPFILTERS",
        "LASTDATE",
        "LASTNONBLANK",
        "LCM",
        "LEFT",
        "LEN",
        "LN",
        "LOG",
        "LOG10",
        "LOOKUPVALUE",
        "LOWER",
        "MAX",
        "MAXA",
        "MAXX",
        "MEDIAN",
        "MEDIANX",
        "MID",
        "MIN",
        "MINA",
        "MINUTE",
        "MINX",
        "MOD",
        "MONTH",
        "MROUND",
        "NATURALINNERJOIN",
        "NATURALLEFTOUTERJOIN",
        "NEXTDAY",
        "NEXTMONTH",
        "NEXTQUARTER",
        "NEXTYEAR",
        "NORM.DIST",
        "NORM.INV",
        "NORM.S.DIST",
        "NORM.S.INV",
        "NOT",
        "NOW",
        "ODD",
        "OPENINGBALANCEMONTH",
        "OPENINGBALANCEQUARTER",
        "OPENINGBALANCEYEAR",
        "OR",
        "PARALLELPERIOD",
        "PATH",
        "PATHCONTAINS",
        "PATHITEM",
        "PATHITEMREVERSE",
        "PATHLENGTH",
        "PERCENTILE.EXC",
        "PERCENTILE.INC",
        "PERCENTILEX.EXC",
        "PERCENTILEX.INC",
        "PI",
        "POISSON.DIST",
        "POWER",
        "PREVIOUSDAY",
        "PREVIOUSMONTH",
        "PREVIOUSQUARTER",
        "PREVIOUSYEAR",
        "PRODUCT",
        "PRODUCTX",
        "QUOTIENT",
        "RADIANS",
        "RAND",
        "RANDBETWEEN",
        "RANK.EQ",
        "RANKX",
        "RELATED",
        "RELATEDTABLE",
        "REMOVEFILTERS",
        "REPLACE",
        "REPT",
        "RIGHT",
        "ROUND",
        "ROUNDDOWN",
        "ROUNDUP",
        "ROW",
        "SAMEPERIODLASTYEAR",
        "SAMPLE",
        "SEARCH",
        "SECOND",
        "SELECTCOLUMNS",
        "SELECTEDMEASURE",
        "SELECTEDMEASUREFORMATSTRING",
        "SELECTEDMEASURENAME",
        "SELECTEDVALUE",
        "SIGN",
        "SIN",
        "SINH",
        "SQRT",
        "SQRTPI",
        "STARTOFMONTH",
        "STARTOFQUARTER",
        "STARTOFYEAR",
        "STDEV.P",
        "STDEV.S",
        "STDEVX.P",
        "STDEVX.S",
        "SUBSTITUTE",
        "SUBSTITUTEWITHINDEX",
        "SUM",
        "SUMMARIZE",
        "SUMMARIZECOLUMNS",
        "SUMX",
        "SWITCH",
        "T.DIST",
        "T.DIST.2T",
        "T.DIST.RT",
        "T.INV",
        "T.INV.2t",
        "TAN",
        "TANH",
        "TIME",
        "TIMEVALUE",
        "TODAY",
        "TOPN",
        "TOTALMTD",
        "TOTALQTD",
        "TOTALYTD",
        "TREATAS",
        "TRIM",
        "TRUE",
        "TRUNC",
        "UNICHAR",
        "UNION",
        "UPPER",
        "USERELATIONSHIP",
        "USERNAME",
        "UTCNOW",
        "UTCTODAY",
        "VALUE",
        "VALUES",
        "VAR",
        "VAR.P",
        "VAR.S",
        "VARX.P",
        "VARX.S",
        "WEEKDAY",
        "WEEKNUM",
        "XIRR",
        "XNPV",
        "YEAR",
        "YEARFRAC",
      ],
      searchResult: "",
      onceFormatted: false,
      successUpdateMessage: "",
    };
  },
  mounted() {
    // load document id if exists
    this.code = this.docData.entity_data.code;

    if (this.$route.query.id) {
      this.loadDocument();
      this.onceFormatted = true;
      this.edit = true;
    }

    let localData = localStorage.getItem("temp_app_data");
    if (localData) {
      localData = JSON.parse(localData);
      this.code = localData.entity_data.code;
      this.settings = localData.entity_data.settings;

      localStorage.removeItem("temp_app_data");
    }

    // clone
    if (this.$route.query.clone && this.docData) {
      this.clone();
    }
  },

  methods: {
    formatCode: function (titleSetting = "", event = null) {
      this.checkTitleSetting(titleSetting, event);

      // don't format when there is no code in textarea
      if (!this.code) {
        return;
      } else {
        this.code = this.htmlWrap(this.code);
        this.showResults = true;
      }
    },

    showSettings() {
      if (this.$refs.daxRef.offsetParent === null) {
        this.$refs.daxRef.style.display = "block";
      } else {
        this.$refs.daxRef.style.display = "none";
      }
    },

    checkTitleSetting(titleSetting, event) {
      let data = {
        automatic: (titleSetting == "title_auto" && event) || false,
        comma: (titleSetting == "title_comma" && event) || false,
        semicolon: (titleSetting == "title_semicolon" && event) || false,
      };

      if (!(data.automatic || data.comma || data.semicolon)) {
        data.automatic = true;
      }
      // console.log(data);
      this.settings.setting_title = data;
    },

    onChange(value, $event) {},

    saveDocument() {
      this.$parent.saveDoc(
        null,
        { code: this.code, settings: this.settings },
        "RCode"
      );
      // this.formatCode();
    },

    updateDocument() {
      this.updateBtnText = "UPDATING...";

      this.$parent.updateDoc(
        this.$route.query.id,
        { code: this.code, settings: this.settings },
        "RCode"
      );
      setTimeout(() => {
        this.updateBtnText = "UPDATE";
        this.successUpdateMessage = "Document saved!";
        setTimeout(() => {
          this.successUpdateMessage = "";
        }, 2000);
      }, 1000);
      // this.formatCode();
    },

    loadDocument() {
      this.$parent
        .loadDoc(this.$route.query.id)
        .then(({ data }) => {
          this.document = data.doc;
          this.code = data.entity.code;
          this.settings = data.entity.settings;
          // this.formatCode();
          this.readOnly = !this.$parent.checkIfIamAuthor();

          this.showResults = true;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },

    copyToClipboard() {
      this.$copyText(this.code).then((e) => {
        this.copyCodeBtnText = "COPIED";
        // reset to normal after 2 seconds
        setTimeout(() => {
          this.copyCodeBtnText = "COPY CODE";
        }, 2000);
      });
    },

    clone() {
      this.$parent.settingCloneTitle = true;
    },
    newDoc() {
      window.location.href = "/apps/m-code";
    },

    tabber(event) {
      console.log(event);
      if (event) {
        event.preventDefault();
        let startText = this.chapter.text.slice(0, event.target.selectionStart);
        let endText = this.chapter.text.slice(event.target.selectionStart);
        this.chapter.text = `${startText}\t${endText}`;
        event.target.selectionEnd = event.target.selectionStart + 1;
      }
    },
    htmlWrap: function (data) {
      let dax_functions = [
        "ABS",
        "ACOS",
        "ACOSH",
        "ADDCOLUMNS",
        "ADDMISSINGITEMS",
        "ALL",
        "ALLCROSSFILTERED",
        "ALLEXCEPT",
        "ALLNOBLANKROW",
        "ALLSELECTED",
        "AND",
        "APPROXIMATEDISTINCTCOUNT",
        "ASIN",
        "ASINH",
        "ATAN",
        "ATANH",
        "AVERAGE",
        "AVERAGEA",
        "AVERAGEX",
        "BETA.DIST",
        "BETA.INV",
        "BLANK",
        "CALCULATE",
        "CALCULATETABLE",
        "CALENDAR",
        "CALENDARAUTO",
        "CEILING",
        "CHISQ.INV",
        "CHISQ.INV.RT",
        "CLOSINGBALANCEMONTH",
        "CLOSINGBALANCEQUARTER",
        "CLOSINGBALANCEYEAR",
        "CODE",
        "COMBIN",
        "COMBINA",
        "CONCATENATE",
        "CONCATENATEX",
        "CONFIDENCE.NORM",
        "CONFIDENCE.T",
        "CONTAINS",
        "CONTAINSSTRING",
        "CONTAINSSTRINGEXACT",
        "CONVERT",
        "COS",
        "COSH",
        "COUNT",
        "COUNTA",
        "COUNTAX",
        "COUNTBLANK",
        "COUNTROWS",
        "COUNTX",
        "CROSSFILTER",
        "CROSSJOIN",
        "CURRENCY",
        "CUSTOMDATA",
        "DATATABLE",
        "DATE",
        "DATEADD",
        "DATEDIFF",
        "DATESBETWEEN",
        "DATESINPERIOD",
        "DATESMTD",
        "DATESQTD",
        "DATESYTD",
        "DATEVALUE",
        "DAY",
        "DEGREES",
        "DISTINCT (column)",
        "DISTINCT (table)",
        "DISTINCTCOUNT",
        "DISTINCTCOUNTNOBLANK",
        "DIVIDE",
        "EARLIER",
        "EARLIEST",
        "EDATE",
        "ENDOFMONTH",
        "ENDOFQUARTER",
        "ENDOFYEAR",
        "EOMONTH",
        "ERROR",
        "EVEN",
        "EXACT",
        "EXCEPT",
        "EXP",
        "EXPON.DIST",
        "FACT",
        "FALSE",
        "FILTER",
        "FILTERS",
        "FIND",
        "FIRSTDATE",
        "FIRSTNONBLANK",
        "FIXED",
        "FLOOR",
        "FORMAT",
        "GCD",
        "GENERATE",
        "GENERATEALL",
        "GENERATESERIES",
        "GEOMEAN",
        "GEOMEANX",
        "GROUPBY",
        "HASONEFILTER",
        "HASONEVALUE",
        "HOUR",
        "IF",
        "IFERROR",
        "IN",
        "CONTAINSROW",
        "INT",
        "INTERSECT",
        "ISBLANK",
        "ISCROSSFILTERED",
        "ISEMPTY",
        "ISERROR",
        "ISEVEN",
        "ISFILTERED",
        "ISINSCOPE",
        "ISLOGICAL",
        "ISNONTEXT",
        "ISNUMBER",
        "ISO.CEILING",
        "ISONORAFTER",
        "ISSELECTEDMEASURE",
        "ISTEXT",
        "KEEPFILTERS",
        "LASTDATE",
        "LASTNONBLANK",
        "LCM",
        "LEFT",
        "LEN",
        "LN",
        "LOG",
        "LOG10",
        "LOOKUPVALUE",
        "LOWER",
        "MAX",
        "MAXA",
        "MAXX",
        "MEDIAN",
        "MEDIANX",
        "MID",
        "MIN",
        "MINA",
        "MINUTE",
        "MINX",
        "MOD",
        "MONTH",
        "MROUND",
        "NATURALINNERJOIN",
        "NATURALLEFTOUTERJOIN",
        "NEXTDAY",
        "NEXTMONTH",
        "NEXTQUARTER",
        "NEXTYEAR",
        "NORM.DIST",
        "NORM.INV",
        "NORM.S.DIST",
        "NORM.S.INV",
        "NOT",
        "NOW",
        "ODD",
        "OPENINGBALANCEMONTH",
        "OPENINGBALANCEQUARTER",
        "OPENINGBALANCEYEAR",
        "OR",
        "PARALLELPERIOD",
        "PATH",
        "PATHCONTAINS",
        "PATHITEM",
        "PATHITEMREVERSE",
        "PATHLENGTH",
        "PERCENTILE.EXC",
        "PERCENTILE.INC",
        "PERCENTILEX.EXC",
        "PERCENTILEX.INC",
        "PI",
        "POISSON.DIST",
        "POWER",
        "PREVIOUSDAY",
        "PREVIOUSMONTH",
        "PREVIOUSQUARTER",
        "PREVIOUSYEAR",
        "PRODUCT",
        "PRODUCTX",
        "QUOTIENT",
        "RADIANS",
        "RAND",
        "RANDBETWEEN",
        "RANK.EQ",
        "RANKX",
        "RELATED",
        "RELATEDTABLE",
        "REMOVEFILTERS",
        "REPLACE",
        "REPT",
        "RIGHT",
        "ROUND",
        "ROUNDDOWN",
        "ROUNDUP",
        "ROW",
        "SAMEPERIODLASTYEAR",
        "SAMPLE",
        "SEARCH",
        "SECOND",
        "SELECTCOLUMNS",
        "SELECTEDMEASURE",
        "SELECTEDMEASUREFORMATSTRING",
        "SELECTEDMEASURENAME",
        "SELECTEDVALUE",
        "SIGN",
        "SIN",
        "SINH",
        "SQRT",
        "SQRTPI",
        "STARTOFMONTH",
        "STARTOFQUARTER",
        "STARTOFYEAR",
        "STDEV.P",
        "STDEV.S",
        "STDEVX.P",
        "STDEVX.S",
        "SUBSTITUTE",
        "SUBSTITUTEWITHINDEX",
        "SUM",
        "SUMMARIZE",
        "SUMMARIZECOLUMNS",
        "SUMX",
        "SWITCH",
        "T.DIST",
        "T.DIST.2T",
        "T.DIST.RT",
        "T.INV",
        "T.INV.2t",
        "TAN",
        "TANH",
        "TIME",
        "TIMEVALUE",
        "TODAY",
        "TOPN",
        "TOTALMTD",
        "TOTALQTD",
        "TOTALYTD",
        "TREATAS",
        "TRIM",
        "TRUE",
        "TRUNC",
        "UNICHAR",
        "UNION",
        "UPPER",
        "USERELATIONSHIP",
        "USERNAME",
        "UTCNOW",
        "UTCTODAY",
        "VALUE",
        "VALUES",
        "VAR",
        "VAR.P",
        "VAR.S",
        "VARX.P",
        "VARX.S",
        "WEEKDAY",
        "WEEKNUM",
        "XIRR",
        "XNPV",
        "YEAR",
        "YEARFRAC",
      ];
      let js_vars = { dax_functions: dax_functions };

      var DAXreservedWords = js_vars.dax_functions;

      if (
        this.settings.setting_title &&
        this.settings.setting_title.automatic
      ) {
        if (data.indexOf(",") != "-1") {
          this.settings.setting_title.comma = true;
          this.settings.setting_title.semicolon = false;
        } else if (data.indexOf(";") != "-1") {
          this.settings.setting_title.comma = false;
          this.settings.setting_title.semicolon = true;
        }
      }

      data = data.replace(/;/g, ",");

      // To make it easier
      data = data.replace(/,/g, " , ");
      data = data.replace(/ =/g, "=");
      data = data.replace(/= /g, "=");
      data = data.replace(/=/g, " = ");
      data = data.replace(/\/\//g, "C--------C");
      // make sure the comments stay right
      data = data.replace(/(?:\r\n|\r|\n)/g, " ReturnLinePlaceHolder ");
      // data = data.replace(/[{(}]/g, ' (');
      let dataArray = data.split(" ");
      dataArray.forEach(function (word, index) {
        if (DAXreservedWords.indexOf(word.toLocaleUpperCase().trim()) > -1) {
          dataArray[index] = word.toLocaleUpperCase();
        }
      });
      data = dataArray.join(" ");
      data = data.replace(/ReturnLinePlaceHolder/g, "\n");
      returnData = data.replace(/=/g, "EQULSIGN");
      if (!this.settings.lines.long_lines) {
        returnData = sqlFormatter.format(returnData, {
          indent: "    ", // Defaults to two spaces
        });
      } else {
        returnData = sqlFormatter2.format(returnData, {
          indent: "    ", // Defaults to two spaces
        });
      }
      returnData = returnData.split("\nEQULSIGN").join("EQULSIGN");
      returnData = returnData.split("EQULSIGN").join(" =");
      // returnData = returnData.replace(/--/g, "//");
      returnData = returnData.replace(/& &/g, "&&");
      returnData = returnData.replace(/: =/g, ":=");
      // Easy removal of hte 'space'
      returnData = returnData.split(" (");
      returnData = returnData.join("(");

      returnData = returnData.split("(");

      if (this.settings.spacing.best_practice)
        returnData = returnData.join("(");
      else returnData = returnData.join(" (");

      returnData = returnData.replace("= ", "=\n"); //only the first
      returnData = returnData.replace("RETURN ", "\nRETURN\n");
      returnData = returnData.replace(/VAR/g, "\nVAR");
      returnData = returnData.replace(/\t\nVAR/g, "\tVAR");
      returnData = returnData.replace(/=\n\nVAR/g, "=\nVAR");
      returnData = returnData.replace("\n\n", "\n");

      //Remove empty lines
      var returnData = returnData.replace(/(^[ \t]*\n)/gm, "");

      returnData = returnData.split("< >").join("<>");
      returnData = returnData.split("> =").join(">=");
      returnData = returnData.split("< =").join("<=");
      returnData = returnData.split("& &").join("&&");
      returnData = returnData.split(" '").join("'");
      returnData = returnData.split("' ").join("'");
      returnData = returnData.split("RETURN").join("\nRETURN");

      var split_arr = returnData.split("");

      var returnData = [];

      split_arr.forEach(function (item, index) {
        var next = split_arr[index + 1];
        var prev = split_arr[index - 1];

        if (
          item == "(" &&
          typeof next != "undefined" &&
          next != " " &&
          next != "\n"
        ) {
          returnData.push(item + " ");
        } else if (
          item == ")" &&
          typeof prev != "undefined" &&
          prev != " " &&
          prev != "\n"
        ) {
          returnData.push(" " + item);
        } else if (item == " " && typeof next != "undefined" && next == "]") {
          //Element not needed
        } else if (item == " " && typeof next != "undefined" && next == "[") {
          //Element not needed
          returnData.push(item);
        } else {
          returnData.push(item);
        }
      });

      returnData = returnData.join("");

      returnData = returnData.split("(  )").join("()");

      if (this.settings.setting_title.semicolon)
        returnData = returnData.split(",").join(";");

      returnData = returnData.split('",\n').join('",');
      returnData = returnData.split('";\n').join('";');

      var split_arr = returnData.split("\n");

      var returnData = [];

      split_arr.forEach(function (item, index) {
        var spaces = item.search(/\S/);
        if (spaces > 1) spaces = spaces - 1;
        if (spaces > 0) var spaces_str = " ".repeat(spaces);
        else var spaces_str = "";
        item = item.replace(/\s+/g, " ");
        item = spaces_str + item;

        if (item.indexOf("&&") != -1 || item.indexOf("||") != -1) {
          item = item.split("&&").join("&&\n" + spaces_str + "");
          item = item.split("||").join("||\n" + spaces_str + "");
          returnData.push(item);
        } else {
          returnData.push(item);
        }
      });

      returnData = returnData.join("\n");

      returnData = returnData.split("< >").join("<>");
      returnData = returnData.split("> =").join(">=");
      returnData = returnData.split("< =").join("<=");
      returnData = returnData.split("& &").join("&&");
      returnData = returnData.split(" '").join("'");
      returnData = returnData.split("' ").join("'");
      returnData = returnData.split("('").join("( '");
      returnData = returnData.split("')").join("' )");

      returnData = returnData.split("<>'").join("<> '");
      returnData = returnData.split(">='").join(">= '");
      returnData = returnData.split("<='").join("<= '");
      returnData = returnData.split("&&'").join("&& '");
      returnData = returnData.split("='").join("= '");
      returnData = returnData.split("<'").join("< '");
      returnData = returnData.split(">'").join("> '");
      returnData = returnData.split("<>[").join("<> [");
      returnData = returnData.split(">=[").join(">= [");
      returnData = returnData.split("<=[").join("<= [");
      returnData = returnData.split("&&[").join("&& [");
      returnData = returnData.split("=[").join("= [");
      returnData = returnData.split("<[").join("< [");
      returnData = returnData.split(">[").join("> [");
      returnData = returnData.split("+ ,").join("+,");
      returnData = returnData.split("+,").join("+, ");

      // returnData = returnData.split(", ").join(",");
      // returnData = returnData.split(" ,").join(",");
      // returnData = returnData.split(",").join(", ");
      // returnData = returnData.split("; ").join(";");
      // returnData = returnData.split(" ;").join(";");
      // returnData = returnData.split(";").join("; ");

      returnData = returnData.replace(/C --------C/g, "C--------C");
      returnData = returnData.split("C--------C").join("//");

      var alpahbet = String.fromCharCode(...Array(123).keys()).slice(97);
      alpahbet = alpahbet.split("");
      alpahbet.forEach(function (value) {
        returnData = returnData.split(value + " [").join(value + "[");
        returnData = returnData
          .split(value.toUpperCase() + " [")
          .join(value.toUpperCase() + "[");
      });

      return returnData;
    },
  },
};
</script>

<style scoped>
.btn-edit-rawcode {
  color: #ffffff;
  background-color: #fa2e05;
  border: 2px solid #fa2e05;
}

.dax-search-code-form .form-control {
  border-left: 5px solid #fa2e05;
  font-family: "Fira Sans", sans-serif;
  color: #a2a2a2;
}

.line-numbers .line-numbers-rows {
  border-right: 5px solid #fa2e05 !important;
  width: 4em !important;
  left: -4.8em !important;
}

.dax-settings-box {
  max-width: 200px;
}

:root {
  touch-action: pan-x pan-y;
  height: 100%;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #a8a8a8;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a8a8a8;
  font-weight: bold;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #a8a8a8;
  font-weight: bold;
}

.container-fluid-height {
  min-height: 80vh;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
@media screen and (min-width: 1200px) {
  .container-fluid-height {
    min-height: 65vh;
    height: 65vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
}

[v-cloak] {
  display: none !important;
}
:root {
  touch-action: pan-x pan-y;
  height: 100%;
}

pre[class*="language-"].line-numbers {
  padding-bottom: 20px;
}

.bottom-edited-btn {
  width: 120%;
}

@media screen and (min-width: 786px) {
  .bottom-edited-btn {
    margin: auto -60px;
    width: unset;
  }
}
</style>
